import React, { useEffect, useState } from "react";
import Sidebar from "../../common/Sidebar/Sidebar";
import Header from "../../common/Header/Header";
import action from "../../asessts/Images/action_eye.svg";
import client from "../../services/Client";
// import product from "../../asessts/Images/borrower-empty.png";
import Loading from "../../common/Loading/Loading";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { setCurrentPage } from "../../redux/slices/currentPageSlice";

function ItemList() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentPage = useSelector(
    (state) => state.currentPageSlice.currentPage
  );

  const fetchPosts = async (page = 1) => {
    try {
      setIsLoading(true);
      const response = await client.get(
        `/app/admin/items/total-items-listed?page=${page}`
      );

      const resData = response?.data?.response;
      setItems(resData?.data || []);
      setTotal(resData?.total || 0);
      setPerPage(resData?.perPage || 10);
      dispatch(setCurrentPage(resData?.currentPage || 1));
      setIsLoading(false);
    } catch (error) {
      console.log("Error while fetching posts", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = async (newPage) => {
    if (newPage >= 1 && newPage <= Math.ceil(total / perPage)) {
      fetchPosts(newPage);
      navigate(`/item-listed?page=${newPage}`);
    }
  };

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <div className="main-dashboard subadmin-dashboard">
        <Header title={"Items"} />
        <div className="loaction-list-main">
          <div className="table-data-main">
            <div className="table-data table-data-two">
              <table border="0" cellPadding="0" style={{ width: "100%" }}>
                <thead
                  style={{
                    backgroundColor: "#FDFDFD",
                    borderBottom: "1px solid #EDEDED",
                    borderTop: "1px solid #ededed",
                  }}
                >
                  <tr>
                    <th className="heading">Title</th>
                    <th className="heading">Lender Name</th>
                    <th className="heading">Brand Name</th>
                    <th className="heading">Rental Price Per Day</th>
                    <th className="heading">Listing Date</th>
                    <th className="heading">Status</th>
                    <th className="heading" style={{ width: "7%" }}>
                      Action
                    </th>
                  </tr>
                </thead>
                {isLoading ? (
                  <Loading />
                ) : (
                  <tbody>
                    {items?.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center no_data-image">
                          {/* <img
                            style={{ padding: "120px" }}
                            src={product}
                            alt="no_data_image"
                          /> */}
                          <div style={{ padding: "120px" }}>
                            {" "}
                            No Data Found!
                          </div>
                        </td>
                      </tr>
                    ) : (
                      items.map((item) => (
                        <tr
                          key={item.listId}
                          style={{ borderBottom: "1px solid #EDEDED" }}
                        >
                          <td className="table-col">{item.category}</td>
                          <td className="table-col">
                            {item.lenderDetails?.name}
                          </td>
                          <td className="table-col">{item.brand?.name}</td>
                          <td className="table-col">
                            {item.rentalPricePerDay} €
                          </td>
                          <td className="table-col">
                            {new Date(item.listingDate).toLocaleDateString()}
                          </td>
                          <td
                            className="table-col"
                            style={{ textTransform: "capitalize" }}
                          >
                            {item.status}
                          </td>
                          <td
                            style={{ textAlign: "center" }}
                            className="table-col"
                          >
                            <button className="action-btn">
                              <Link to={`/item-details/${item.listId}`}>
                                <img src={action} alt="view" />
                              </Link>
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                )}
              </table>
            </div>
          </div>
        </div>

        {items?.length > 0 && (
          <div className="next-previous-slide">
            <div className="slides-heading">
              <span>
                Showing {(currentPage - 1) * perPage + 1} to{" "}
                {Math.min(currentPage * perPage, total)} out of {total}
              </span>
            </div>

            <div className="slides-button">
              <ul className="d-flex justify-center align-items-center p-0 m-0">
                <li>
                  <button
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    <i
                      className="fa fa-angle-left"
                      aria-hidden="true"
                      style={{ cursor: "pointer", color: "#333" }}
                    ></i>
                  </button>
                </li>
                <li className="d-flex justify-center align-items-center">
                  {Array.from({ length: Math.ceil(total / perPage) }).map(
                    (_, index) => {
                      if (
                        index < 2 ||
                        index > Math.ceil(total / perPage) - 3 ||
                        (index >= currentPage - 2 && index <= currentPage + 1)
                      ) {
                        return (
                          <button
                            key={index + 1}
                            onClick={() => handlePageChange(index + 1)}
                            className={
                              currentPage === index + 1 ? "active-slide" : ""
                            }
                          >
                            {index + 1}
                          </button>
                        );
                      } else if (
                        index === 2 ||
                        index === Math.ceil(total / perPage) - 3
                      ) {
                        return <span key={index}>...</span>;
                      }
                      return null;
                    }
                  )}
                </li>
                <li>
                  <button
                    disabled={currentPage === Math.ceil(total / perPage)}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    <i
                      className="fa fa-angle-right"
                      aria-hidden="true"
                      style={{ cursor: "pointer" }}
                    ></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ItemList;
